import { doFetch } from '.';

export const createAccount = async (
  body: any
): Promise<{
  error: string;
  account: any;
}> => {
  return await doFetch('account', 'POST', body);
};

export const getAccounts = async (
  accessToken: string
): Promise<{
  error: string;
  subaccounts: any[];
}> => {
  return await doFetch(`subaccounts?accessToken=${accessToken}`, 'GET');
};

export const getUser = async (
  email: string,
  accessToken: string
): Promise<{
  error: string;
  account: any;
  user: any;
}> => {
  return await doFetch(
    `users?email=${email}&accessToken=${accessToken}`,
    'GET'
  );
};

export const updateAccount = async (
  body: any
): Promise<{
  error: string;
  account: any;
}> => {
  return await doFetch(`account`, 'PUT', body);
};

export const deactivateAccount = async (
  uid: string,
  accessToken: string
): Promise<{
  error: string;
  success: boolean;
}> => {
  return await doFetch(`account/deactivate`, 'PUT', { uid, accessToken });
};

export const deleteAccount = async (
  uid: string
): Promise<{
  error: string;
  success: boolean;
}> => {
  return await doFetch(`account`, 'DELETE', { uid });
};
